import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { LANGUAGES, translate } from '../data/i18n';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('sman_lang') || 'en');

  useEffect(() => {
    localStorage.setItem('sman_lang', lang);
    const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[1];
    document.documentElement.dir = meta.dir;
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => translate(lang, key), [lang]);
  const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[1];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, meta, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
